// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2DQrn","signatureButtonsRight":"ModalSign_signatureButtonsRight__1Lcnl"};